<template>
  <div :class="{ 'c-disabled-block' : readonly || deprecated }">
    <el-form-item class="content_label">

      <div class="single-content__title u-mb1">
        <div class="single-content__name">
          {{content.name}}
          <el-popover
                  placement="top-start"
                  :title="content.name"
                  width="700"
                  trigger="hover">
            <icon class="u-mr1 content-help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
            <div class="content-help">
              <div class="content-setting__description">
                <span v-html="content.description.length == 0 ? '<ul><li>Coming soon</li></ul>' : content.description "/>
              </div>
            </div>
          </el-popover>
          <em class="u-text--sm u-text--light u-ml3">{{content.section.slug}}.{{content.slug}}</em>
        </div>
      </div>

      <div class="u-mt2 c-disabled-block__message single-content__message" v-if="adminOnly && !deprecated">
        <icon class="u-mr2" name="lock"></icon>
        Content for administrators Only.
      </div>
      <div class="u-mt2 c-disabled-block__message single-content__message" v-if="deprecated">
        <icon class="u-mr2" name="lock"></icon>
        This content is deprecated and can no longer be changed.
      </div>
      <div class="c-disabled-block__message single-content__message" v-if="readonly">
        <icon class="u-mr2" name="exclamation-triangle"></icon>
        Content is 'Read Only'. Please contact BriteApps team for assistance.
      </div>

      <div v-if="content.default.length > 13">
        <el-input type="textarea" v-model="displayValueComputed" @change="saveModifiedContent" @blur="saveModifiedContent"></el-input>
      </div>
      <div v-else>
        <el-input v-model="displayValueComputed"  @change="saveModifiedContent" @blur="saveModifiedContent"></el-input>
      </div>

      <div v-if="displayValue != content.default">
        <span class="u-text--light u-text--sm">Default text: <em>{{content.default}}</em></span>
        <el-button class="single-content__btn" title="Reset content to the default value" @click="askReset()" v-if="!readonly && !deprecated">Reset</el-button>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: ['content'],
  name: 'ba-single-content',
  data () {
    let carrierAccess = this.content.carrier_access
    let contentValue = this.content.overridden ? this.content.overridden.value : this.content.default
    let initialValue = contentValue
    return {
      displayValue: contentValue,
      initialValue,
      carrierAccess
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    displayValueComputed: {
      get () {
        return this.displayValue
      },
      set (updatedValue) {
        this.displayValue = updatedValue
      }
    },
    adminOnly () {
      return (this.carrierAccess === 'R') && this.user.is_superuser
    },
    readonly () {
      if (!this.user) {
        return true
      }
      return !this.user.is_superuser && (this.carrierAccess === 'R')
    },
    deprecated () {
      return (this.carrierAccess === 'D')
    }
  },
  methods: {
    ...mapActions('content', ['saveSingleContent']),
    saveModifiedContent (e) {
      console.log('saveModifiedContent')
      let oldValue = this.initialValue
      let newValue = e.target ? e.target.value : e

      this.saveContent(oldValue, newValue, 'saved')
    },
    saveContent (oldValue, newValue, typeOfSave) {
      if (oldValue === newValue) {
        return
      }

      let companyId = this.$route.params.companyId
      let payload = {
        oldValue,
        newValue,
        content: this.content,
        companyId,
      }
      this.displayValue = newValue
      this.initialValue = newValue

      this.saveSingleContent(payload)
        .then(repsonse => {
          this.$notify({
            message: 'Content ' + typeOfSave +' successfully',
            type: 'success'
          })
        })
    },
    askReset () {
      this.$confirm(
        '<div>Are you sure you want to reset the content to the default value?</div>',
        'Content Reset',
        {dangerouslyUseHTMLString: true, confirmButtonText: 'Reset', center: true}
      ).then(() => {
        this.reset()
      })
    },
    reset () {
      let oldValue = this.content.overridden.value
      let newValue = this.content.default
      this.saveContent(oldValue, newValue, 'reset')
    }
  }
}
</script>

<style>
  .el-popover {
    text-align: left !important;
  }

  .el-popover__title {
    text-decoration: underline;
  }

</style>

<style lang="scss">
    @import '../../styles/variables';

    .single-content__btn {
      position: relative;
      height: 30px;
      margin-left: 10px !important;
      line-height: 0 !important;
      top: 0px;
    }

    .single-content__message {
      line-height: 1.15 !important;
    }

    .single-content__title {
      display: flex;
      font-size: 16px;
    }

    .single-content__name {
      flex: auto;
      line-height: 30px;
    }

  .single-content__description {
    /* Treat \r\n as line breaks */
    white-space: pre-line;
    word-break: normal;
  }

  .content-help__icon {
    border-radius: 4px;
    position: relative;
    top: 0.4em;
    color: #455b5f;
    margin: 0 0 3px 10px;
  }

  .content-help__icon:hover {
    color: #d8dce5;
  }

  .content-help {
    line-height: 2em;
    word-break: keep-all;
  }

</style>
